import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getCalendarStart,
    getCalendarSuccess,
    getCalendarFailure
  },
  reducer
} = createSlice({
  name: 'calendar',
  initialState: {
    calendarData: null,
    loading: false,
  },
  reducers: {
    getCalendarStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getCalendarSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      calendarData: payload,
    }),
    getCalendarFailure: (state) => ({
      ...state,
      loading: false
    })
  }
})

export default reducer

export {
  getCalendarStart,
  getCalendarSuccess,
  getCalendarFailure
}
